export class KeyCodeDto {
    keyCode = '';
    orderId= '';
    productType='';
    id=0;
}